import { useContext, useEffect } from 'react';
import styled from 'styled-components';
import { AchievementModalItem } from '~/components/achievement/AchievementModalItem';
import { CommonBasicButton } from '~/components/common/button/CommonBasicButton';
import { CommonPlaneModal } from '~/components/common/modal/CommonPlaneModal';
import { TitleWithCurvedText } from '~/components/common/title/TitleWithCurvedText';
import { ModalContext } from '~/context/ModalContext';
import type { Achievements } from '~/features/stamps/achievements/types/enums';
import { useAchievementStore } from '~/stores';
import { pxVw } from '~/styles/ts/functions';

interface Props {
  id: number;
  achievementType: Achievements;
}

const Container = styled.div`
  padding: ${({ theme }) => pxVw.SP(theme.style === 'en' ? 80 : 64)} 0 0;
`;

const Title = styled.h3`
  position: relative;
  text-align: center;
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-bottom: ${pxVw.SP(48)};
`;

const CloseButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export const AchievementModal = ({ id, achievementType }: Props) => {
  const removeAchievement = useAchievementStore((s) => s.removeAchievement);
  const { closeModal } = useContext(ModalContext);

  useEffect(() => {
    removeAchievement(id, achievementType);
  }, []);

  return (
    <CommonPlaneModal size="672-1008">
      <Container>
        <Title>
          <TitleWithCurvedText
            id="get_stamp"
            curvedText="スタンプゲット"
            straightText="GET STAMP!"
          />
        </Title>
        <AchievementModalItem achievementType={achievementType} />
        <CloseButtonWrapper>
          <CommonBasicButton
            size="400-112"
            colorType="positive"
            text="event_btn_close"
            onClick={closeModal}
          />
        </CloseButtonWrapper>
      </Container>
    </CommonPlaneModal>
  );
};
